import React, { useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

import ActiveLearningClassDataContents from "../../../templates/teacher/ActiveLearningClassDataContents";
import {
  Context,
  fetchActiveLearningStudentAnswers,
  fetchActiveLearningThemes,
  fetchActiveLearningMaterialLessonsData,
  fetchClassesByGrade,
} from "../../../teacherStore";

export default () => {
  const { dispatch } = useContext(Context);
  const { class_id, student_id } = useParams();

  useEffect(() => {
    dispatch(fetchActiveLearningThemes());
    dispatch(fetchActiveLearningMaterialLessonsData());
    dispatch(fetchClassesByGrade());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchActiveLearningStudentAnswers(Number(student_id)));
  }, [class_id, student_id, dispatch]);

  return <ActiveLearningClassDataContents />;
};
